export const selectItemHistory = [
  {
    label: '計測時間帯',
    key: 'day',
    options: [
      {
        value: '0',
        label: '一日',
      },
      {
        value: '1',
        label: '午前',
      },
      {
        value: '2',
        label: '午後',
      },
    ],
  },
  {
    label: '表示期間',
    key: 'range',
    options: [
      {
        value: '1',
        label: '日',
      },
      {
        value: '2',
        label: '週',
      },
      {
        value: '3',
        label: '月',
      },
    ],
  },
]

export const selectInformation = {
  label: '表示情報',
  value: 'kg',
  options: [
    {
      value: 'kg',
      label: 'Kg',
    },
    {
      value: 'percent',
      label: '%',
    },
    {
      value: 'BMI',
      label: 'BMI',
    },
    {
      value: 'metabolic_age',
      label: '体内年齢',
    },
    {
      value: 'visceral_fat',
      label: '内臓脂肪',
    },
    {
      value: 'BMR',
      label: '基礎代謝',
    },
  ],
}
